import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import FindEngineer from "./pages/FindEngineer";
import ForEngineers from "./pages/ForEngineers";
import OurStandards from "./pages/OurStandards";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import EngineerLogin from "./pages/EngineerLogin";
import EngineerDashboard from "./pages/EngineerDashboard";
import EngineerSuccess from "./pages/EngineerSuccess";
import LocationPage from "./pages/LocationPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Partners from "./pages/Partners";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/find-engineer" element={<FindEngineer />} />
              <Route path="/find-engineer/:location" element={<LocationPage />} />
              <Route path="/for-engineers" element={<ForEngineers />} />
              <Route path="/standards" element={<OurStandards />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/partners" element={<Partners />} />
              
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              
              {/* Engineer Routes */}
              <Route path="/engineer/login" element={<EngineerLogin />} />
              <Route path="/engineer/dashboard" element={<EngineerDashboard />} />
              <Route path="/engineer/success" element={<EngineerSuccess />} />
            </Routes>
          </main>
          <Footer />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
